// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';
import 'fg-frontend/plugins/jquery.gm';

export default class GoogleMap extends WebComponent {
  didMount() {
    const {
            url,
            popup,
          } = this.props;

    const $map = $(this.element);
    const $mapHeader = $('div[data-fragment="MAP_HEADER"]');
    const $card = $('div[data-fragment="MAP_CARD"]');
    const $cardClose = $('span[data-fragment="MAP_CARD_CLOSE"]');
    const $cardContent = $('div[data-fragment="MAP_CARD_CONTENT"]');

    window.web = window.web || {};
    var web = window.web;

    web.googlemaps = web.googlemaps || {};
    web.googlemaps.activeMarker = null;

    let startingPosition = {
      lat:  49.55,
      lng:  16.45,
      zoom: 8,
    };

    if ( window.innerWidth < 1535 ) {
      startingPosition = {
        lat:  49.55,
        lng:  16.45,
        zoom: 7,
      };
    }

    if ( window.innerWidth < 768 ) {
      startingPosition = {
        lat:  50,
        lng:  16.45,
        zoom: 6,
      };
    }

    if ( popup ) {
      startingPosition = {
        lat:  49.4,
        lng:  16.1,
        zoom: 7,
      };
    }

    /**
     * googlemap base setup
     */
    $.googlemap.setDefaults({
      mapOptions:  {
        startingPosition:  startingPosition,
        minZoom:           3,
        mapTypeControl:    false,
        scaleControl:      false,
        panControl:        true,
        streetViewControl: false,
        zoomControl:       true,
        scrollwheel:       false,
        styles:            [
          {
            'featureType': 'administrative',
            'elementType': 'labels',
            'stylers':     [
              {
                'visibility': 'on',
              },
              {
                'gamma': '1.82',
              },
            ],
          },
          {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers':     [
              {
                'visibility': 'on',
              },
              {
                'gamma': '1.96',
              },
              {
                'lightness': '-9',
              },
            ],
          },
          {
            'featureType': 'administrative',
            'elementType': 'labels.text.stroke',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers':     [
              {
                'visibility': 'on',
              },
              {
                'lightness': '25',
              },
              {
                'gamma': '1.00',
              },
              {
                'saturation': '-100',
              },
            ],
          },
          {
            'featureType': 'poi.business',
            'elementType': 'all',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.park',
            'elementType': 'all',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road',
            'elementType': 'geometry.stroke',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road',
            'elementType': 'labels.icon',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers':     [
              {
                'hue': '#ffaa00',
              },
              {
                'saturation': '-43',
              },
              {
                'visibility': 'on',
              },
            ],
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road.highway',
            'elementType': 'labels',
            'stylers':     [
              {
                'visibility': 'simplified',
              },
              {
                'hue': '#ffaa00',
              },
              {
                'saturation': '-70',
              },
            ],
          },
          {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'labels',
            'stylers':     [
              {
                'visibility': 'on',
              },
            ],
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'all',
            'stylers':     [
              {
                'visibility': 'on',
              },
              {
                'saturation': '-100',
              },
              {
                'lightness': '30',
              },
            ],
          },
          {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers':     [
              {
                'saturation': '-100',
              },
              {
                'lightness': '40',
              },
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'transit.station.airport',
            'elementType': 'geometry.fill',
            'stylers':     [
              {
                'visibility': 'on',
              },
              {
                'gamma': '0.80',
              },
            ],
          },
          {
            'featureType': 'water',
            'elementType': 'all',
            'stylers':     [
              {
                'visibility': 'off',
              },
            ],
          },
        ],
      },
      markerTypes: [
        // default marker, empty
        {},
        {
          icon:  {
            url:    '/img/u/markers.png?v01',
            size:   new google.maps.Size(25, 25),
            origin: new google.maps.Point(17, 82),
            anchor: new google.maps.Point(12, 12),
          },
          shape: {
            coords: [ 12, 12, 12 ],
            type:   'circle',
          },
        },
        {
          icon:  {
            url:    '/img/u/markers.png?v01',
            size:   new google.maps.Size(25, 25),
            origin: new google.maps.Point(17, 246),
            anchor: new google.maps.Point(12, 12),
          },
          shape: {
            coords: [ 12, 12, 12 ],
            type:   'circle',
          },
        },
      ],
    });

    // listeners on google markers
    web.googlemaps.loadMarkersListeners = {
      click: function (e, data, marker) {
        // clicking on inactive marker
        if ( marker.opened ) {

          web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, false);
          web.googlemaps.activeMarker = null;
          marker.opened = false;
          $cardContent.empty();
          $card.removeClass('active');
          $mapHeader.addClass('active');

        } else {

          // inactivate previously activated marker
          if ( web.googlemaps.activeMarker && web.googlemaps.activeMarker.opened ) {
            web.googlemaps.activeMarker.opened = false;
            web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(web.googlemaps.activeMarker, false);
            web.googlemaps.activeMarker = null;
          }

          // set current marker active
          web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, true);
          web.googlemaps.activeMarker = marker;
          marker.opened = true;

          // render custom bubble
          $cardContent.html(web.googlemaps.createCard(data));
          $card.addClass('active');
          $mapHeader.removeClass('active');
        }
      },
    };

    // close button
    $cardClose.click(function (e) {
      web.googlemaps.activeMarker.opened = false;
      web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(web.googlemaps.activeMarker, false);
      web.googlemaps.activeMarker = null;
      $card.removeClass('active');
      $mapHeader.addClass('active');
      setTimeout(() => {
        $cardContent.empty();
      }, 300);
    });

    // set activity color of the marker
    web.googlemaps.setMarkerIcon = function (marker, active) {
      if ( active ) {
        marker.originalData = {
          x:      marker.getIcon().origin.x,
          y:      marker.getIcon().origin.y,
          url:    marker.getIcon().url,
          size:   marker.getIcon().size,
          anchor: marker.getIcon().anchor,
          shape:  marker.getIcon().shape,
        }
      }
      var iconProperties = {
        icon:  {
          origin: active ? new google.maps.Point(0, marker.originalData.y - 82) : new google.maps.Point(marker.originalData.x, marker.originalData.y),
          url:    marker.originalData.url,
          size:   active ? new google.maps.Size(60, 82) : marker.originalData.size,
          anchor: active ? new google.maps.Point(30, 82) : marker.originalData.anchor,
        },
        shape: active ? {
          coords: [ 30, 0, 50, 8, 60, 28, 30, 82, 0, 28, 8, 8 ],
          type:   'poly',
        } : marker.originalData.shape,
      };

      marker.setOptions(iconProperties);

      return active ? marker : null;
    };

    // create googlemap card
    web.googlemaps.createCard = function (data) {
      var str = '';
      var btnClass = '';
      if ( data.motive && data.motive != '' ) {
        str += '<div class="map-card__motive"><img src="' + data.motive + '" alt="">';
        str += '<a class="map-card__btn" href="' + data.link + '">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'shopDetail') + '</a>';
        str += '</div>';
        btnClass = ' map-card__btn--hidden';
      }
      str += '<div class="map-card__content">';
      str += '<h4 class="map-card__title">' + data.title + '</h4>';
      if ( data.type == 1 ) str += '<h4 class="map-card__headline">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'showroom') + ':</h4>';
      if ( data.type == 2 ) str += '<h4 class="map-card__headline">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'contractor') + ':</h4>';
      if ( data.address && data.address != '' ) {
        str += '<p>' + data.address + '</p>';
      }
      if ( data.phone && data.phone != '' ) {
        str += '<p>' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'phone') + ': <span class="phone-number">' + data.phone + '</span></p>';
      }
      if ( data.email && data.email != '' ) {
        str += '<p>' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'email') + ': <a href="mailto:' + data.email + '">' + data.email + '</a></p>';
      }
      if ( data.web && data.web != '' ) {
        str += '<p>' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'web') + ': <a href="' + data.web + '">' + data.web + '</a></p>';
      }
      if ( data.openingHours && data.openingHours != '' ) {
        str += '<h4 class="map-card__headline">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'openingHours') + ':</h4>' + data.openingHours + '';
      }
      if ( data.saleTentOpeningHours && data.saleTentOpeningHours != '' ) {
        if ( data.saleTentTitle && data.saleTentTitle != '' ) {
          str += '<h4 class="map-card__headline">' + data.saleTentTitle + ':</h4>';
        } else {
          str += '<h4 class="map-card__headline">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'saleTentOpeningHours') + ':</h4>';
        }
        str += data.saleTentOpeningHours;
      }
      str += '<a class="map-card__btn' + btnClass + '" href="' + data.link + '">' + web.googlemaps.getText(($('html').attr('lang') || 'cs'), 'shopDetail') + '</a>';
      str += '</div>';
      return str;
    };

    web.googlemaps.getText = function (lang, textId) {
      var structure = {
        'cs': {
          'shopDetail':           'Detail studia',
          'showroom':             'Vzorkovna',
          'contractor':           'Partnerská prodejna',
          'phone':                'Telefon',
          'email':                'E-mail',
          'web':                  'Web',
          'openingHours':         'Otevírací doba prodejny',
          'saleTentOpeningHours': 'Otevírací doba výprodejového stanu',
        },
        'en': {},
      };

      return structure[ lang ][ textId ];
    };

    $map.googlemap();

    $map.googlemap('loadMarkers', {
      dataUrl:           url,
      dataSetName:       'data',
      disableInfowindow: true,
      listeners:         web.googlemaps.loadMarkersListeners || null,
    });

    window.google.maps._$map = $map;
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMap.js